import { render, staticRenderFns } from "./AnalysisDetails.vue?vue&type=template&id=bc2d3438&scoped=true"
import script from "./AnalysisDetails.vue?vue&type=script&lang=js"
export * from "./AnalysisDetails.vue?vue&type=script&lang=js"
import style0 from "./AnalysisDetails.vue?vue&type=style&index=0&id=bc2d3438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2d3438",
  null
  
)

export default component.exports